/*
  This is a standard library logger template.  You can just copy it into a new library as-is.
  This file must exist within the library to access the name and version data from the
  library's package.json file.
 */
import type { LoggerInterface } from '../../logging-lib';
import { getLibraryLoggingAttributes, getLogger } from '../../logging-lib';
import packageJson from '../../package.json';

const { name, version } = packageJson;

// returns a logger for this library w/ library-specific context info
const getLibLogger = (attributes?: object): LoggerInterface => {
  const attr = getLibraryLoggingAttributes(name, version, attributes);
  return getLogger(attr);
};

export default getLibLogger;
